var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showing)?_c('video',{ref:"media",staticClass:"zoomed-video",attrs:{"controls":"","loop":_vm.loop},domProps:{"muted":_vm.muted}},[_c('source',{attrs:{"src":_vm.fullUrl,"type":"video/mp4"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }